export default __webpack_public_path__ + "static/media/7.51e75583.png";